// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import 'babel-polyfill'
import Es6Promise from 'es6-promise'
import moment from 'moment'
import Notifications from 'vue-notification'
import { store } from './store/store'
import Icon from './icon.vue'
// import axios from 'axios'
Es6Promise.polyfill()

Vue.component('icon', Icon)

// Moment
window['moment'] = moment
moment.locale('da')

// Vue.use
Vue.use(Notifications)

// Filters
Vue.prototype.$filters = Vue.options.filters // So we can acces the filters in js

window.Userback = {}
window.Userback.access_token = '1845|2538|ZQG51CPZjl7iXvhqCTYNHMYh0lmDamoac5fdH5d0qljoQAPtuO'

window.mobile_resolution = '768px'

// Filters
Vue.filter('formatDate', function (date) {
    return window['moment'](date).format('DD[.] MMMM YYYY')
})

Vue.filter('formatDateTime', function (date) {
    return window['moment'](date).format('DD[.] MMMM YYYY[, kl.] HH:mm:ss')
})

Vue.filter('formatDateShort', function (date) {
    if (date) {
        if (window['moment'].utc(date).local().format('M') === '5') {
            return window['moment'].utc(date).local().format('DD[.] MMM YYYY')
        } else {
            return window['moment'].utc(date).local().format('DD[.] MMM[.] YYYY')
        }
    } else {
        return null
    }
})

Vue.filter('translateRoles', function (result, local) {
    let role = null
    let roleFull = null
    let userGroups = {
        frontdeskemployee: {
            dk: 'frontmedarbejder',
            sys: 'frontdeskemployee'
        },
        caseowner: {
            dk: 'sagsbehandler',
            sys: 'caseowner'
        },
        contractor: {
            dk: 'entreprenør',
            sys: 'contractor'
        },
        localadministrator: {
            dk: 'administrator',
            sys: 'localadministrator'
        }
    }

    // As for right now its only possible to be member of one user-group (role) through the UI

    // Version 1
    result.forEach(re => {
        if (re.toLowerCase().indexOf('admin') !== -1) {
            roleFull = 'localadministrator'
        }
    })
    if (!roleFull) {
        roleFull = result[0]
    }

    for (let i in userGroups) {
        if (roleFull.toLowerCase().indexOf(i.toLowerCase()) !== -1) {
            if (local === 'dk') {
                role = userGroups[i].dk
            } else if (local === 'sys') {
                role = userGroups[i].sys
            }
        }
    }

    return role
})

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
    el: '#app',
    store,
    router,
    template: '<App/>',
    components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js